const FullScreenOverlay = ({ children }) => (
  <div
    sx={{
      position: "fixed",
      width: "100vw",
      height: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "white",
      zIndex: 50,
    }}
  >
    {children}
  </div>
)

export default FullScreenOverlay
